import Avatar from "../Avatar";
import { UserCard } from "../Card";
import React from "react";
import { MdClearAll, MdExitToApp } from "react-icons/md";
import {
  Button,
  ListGroup,
  ListGroupItem,
  Nav,
  Navbar,
  NavItem,
  NavLink,
  Popover,
  PopoverBody,
  Spinner,
} from "reactstrap";
import { Redirect } from "react-router-dom";
import bn from "../../utils/bemnames";
import * as GeneralFunctions from "../../GeneralFunctions";
import userImage from "../../assets/img/user.jpg";
import NotificationSystem from "react-notification-system";
import { NOTIFICATION_SYSTEM_STYLE } from "../../utils/constants";

const bem = bn.create("header");
let permission;

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      isOpenNotificationPopover: false,
      isNotificationConfirmed: false,
      isOpenUserCardPopover: false,
      isLoggedOut: false,
    };
  }

  logout = async () => {
    permission = GeneralFunctions.getPermissions();
    GeneralFunctions.clearFullLocalStorage();
    this.setState({ isLoggedOut: true });
  };

  toggleNotificationPopover = () => {
    this.setState({
      isOpenNotificationPopover: !this.state.isOpenNotificationPopover,
    });

    if (!this.state.isNotificationConfirmed) {
      this.setState({ isNotificationConfirmed: true });
    }
  };

  toggleUserCardPopover = () => {
    this.setState({
      isOpenUserCardPopover: !this.state.isOpenUserCardPopover,
    });
  };

  handleSidebarControlButton = (event) => {
    event.preventDefault();
    event.stopPropagation();

    document.querySelector(".cr-sidebar").classList.toggle("cr-sidebar--open");
  };

  render() {
    if (this.state.isLoggedOut && permission === "rushUser") {
      return <Redirect to={"/userlogin"} />;
    } else if (this.state.isLoggedOut && permission !== "rushUser") {
      return <Redirect to={"/"} />;
    }
    let profile = GeneralFunctions.getAuthUser();
    if (!profile && permission === "rushUser") {
      return <Redirect to={"/userlogin"} />;
    } else if (!profile && permission !== "rushUser") {
      return <Redirect to={"/"} />;
    }
    return (
      <Navbar
        light
        expand
        className={bem.b("#17517B")}
        style={{ backgroundColor: "#17517B", borderBottom: 0, marginBottom: 0 }}
      >
        <Nav navbar className="mr-2" style={{ backgroundColor: "#17517B" }}>
          <Button
            outline
            onClick={this.handleSidebarControlButton}
            color="#17517B"
            style={{ color: "white", borderColor: "white" }}
          >
            <MdClearAll size={25} />
          </Button>
        </Nav>
        <Nav
          navbar
          className={bem.e("nav-right")}
          style={{ backgroundColor: "#17517B" }}
        >
          {localStorage.getItem('loggedInUsingWallet')
            ? <div style={{ display: "block", margin: "auto" }}>
              <span style={{ marginRight: 5, color: "white" }}>
                {GeneralFunctions._getFormatAddress(localStorage.getItem('walletAddress'))}
                <MdExitToApp
                  size="20"
                  style={{ cursor: 'pointer' }}
                  onClick={() => this.logout()}
                />
              </span>
            </div>
            : <>
              <div style={{ display: "block", margin: "auto" }}>
                <span style={{ marginRight: 5, color: "white" }}>
                  Welcome {profile.name}
                </span>
              </div>
              <NavItem>
                <NavLink id="Popover2">
                  <Avatar
                    style={{ marginRight: "10px" }}
                    onClick={this.toggleUserCardPopover}
                    className="can-click"
                    src={userImage}
                  />
                </NavLink>
                <Popover
                  placement="bottom-end"
                  isOpen={this.state.isOpenUserCardPopover}
                  toggle={this.toggleUserCardPopover}
                  target="Popover2"
                  className="p-0 border-0"
                  style={{ minWidth: 250 }}
                >
                  <PopoverBody className="p-0 border-light">
                    <UserCard
                      title={profile.name}
                      subtitle={profile.email}
                      avatar={userImage}
                      className="border-light"
                    >
                      <ListGroup flush>
                        {this.state.showLoader ? (
                          <ListGroupItem
                            tag="button"
                            action
                            className="border-light"
                          >
                            <Spinner size="sm" color="primary" />
                          </ListGroupItem>
                        ) : (
                          <ListGroupItem
                            tag="button"
                            action
                            className="border-light"
                            onClick={() => this.logout()}
                          >
                            <MdExitToApp /> Signout
                          </ListGroupItem>
                        )}
                      </ListGroup>
                    </UserCard>
                  </PopoverBody>
                </Popover>
              </NavItem>
            </>
          }
        </Nav>
        <NotificationSystem
          dismissible={false}
          ref={(notificationSystem) =>
            (this.notificationSystem = notificationSystem)
          }
          style={NOTIFICATION_SYSTEM_STYLE}
        />
      </Navbar>
    );
  }
}

export default Header;
